/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { FuelPurchase } from './FuelPurchase';
import {
    FuelPurchaseFromJSON,
    FuelPurchaseFromJSONTyped,
    FuelPurchaseToJSON,
    FuelPurchaseToJSONTyped,
} from './FuelPurchase';

/**
 * 
 * @export
 * @interface GetFuelPurchasesResponse
 */
export interface GetFuelPurchasesResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetFuelPurchasesResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<FuelPurchase>}
     * @memberof GetFuelPurchasesResponse
     */
    fuelPurchases: Array<FuelPurchase>;
}

/**
 * Check if a given object implements the GetFuelPurchasesResponse interface.
 */
export function instanceOfGetFuelPurchasesResponse(value: object): value is GetFuelPurchasesResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('fuelPurchases' in value) || value['fuelPurchases'] === undefined) return false;
    return true;
}

export function GetFuelPurchasesResponseFromJSON(json: any): GetFuelPurchasesResponse {
    return GetFuelPurchasesResponseFromJSONTyped(json, false);
}

export function GetFuelPurchasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFuelPurchasesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'fuelPurchases': ((json['fuelPurchases'] as Array<any>).map(FuelPurchaseFromJSON)),
    };
}

export function GetFuelPurchasesResponseToJSON(json: any): GetFuelPurchasesResponse {
    return GetFuelPurchasesResponseToJSONTyped(json, false);
}

export function GetFuelPurchasesResponseToJSONTyped(value?: GetFuelPurchasesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'fuelPurchases': ((value['fuelPurchases'] as Array<any>).map(FuelPurchaseToJSON)),
    };
}

